import { Login20 } from '@carbon/icons-react';
import Truedom from '@carbon/icons-react/lib/checkmark--filled/24';
import Falsedom from '@carbon/icons-react/lib/misuse/24';
import Trash from '@carbon/icons-react/lib/trash-can/24';
import styled from 'styled-components';
import { darken } from 'polished';

const True = styled(Truedom)`
  & path {
    fill: ${({ theme }) => theme.colors.success};
  }
`;
const Delete = styled(Trash)`
  & path {
    fill: ${({ theme }) => theme.colors.danger};
  }
  :hover {
    & path {
      fill: ${({ theme }) => darken(0.2, theme.colors.danger)};
    }
  }
`;

const False = styled(Falsedom)`
  & path {
    fill: ${({ theme }) => theme.colors.lightGrey};
  }
`;

const Enter = styled(Login20)`
  & path {
    fill: ${({ theme }) => theme.colors.secondary};
  }
  :hover {
    & path {
      fill: ${({ theme }) => theme.colors.primary};
    }
  }
`;

const BooleanContainer = styled.p`
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ clickable }) => clickable && 'cursor:pointer;'}
`;

const NoData = styled.h4`
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.secondary};
  padding: 5px 0;
`;

const Color = styled.td`
  padding: 5px;
  height: 100%;
  & div {
    width: 10px;
    height: 32px;
    margin: auto;
    background: ${({ color }) => color};
  }
`;

const CloseModal = styled.p`
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.darkGrey};
  font-weight: bold;
`;

export {
  True,
  False,
  BooleanContainer,
  NoData,
  Color,
  CloseModal,
  Enter,
  Delete,
};
